import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of, switchMap } from 'rxjs';

import { DeprecatedIntelligenceSettingsHttpClient } from './intelligence-settings-http-client';
import { DeprecatedIntelligenceSettingsActions } from './intelligence-settings.store';

@Injectable({ providedIn: 'root' })
export class DeprecatedIntelligenceSettingsEffects {
  private readonly http = inject(DeprecatedIntelligenceSettingsHttpClient);
  private readonly actions = inject(Actions);

  private fetch$ = createEffect(() =>
    this.actions.pipe(
      ofType(DeprecatedIntelligenceSettingsActions.fetch),
      switchMap(() =>
        this.http.fetch().pipe(
          map(data => DeprecatedIntelligenceSettingsActions.fetchSuccess({ payload: data })),
          catchError(error =>
            of(DeprecatedIntelligenceSettingsActions.fetchFailed({ payload: error })),
          ),
        ),
      ),
    ),
  );

  private update$ = createEffect(() =>
    this.actions.pipe(
      ofType(DeprecatedIntelligenceSettingsActions.update),
      mergeMap(({ payload }) =>
        this.http.update(payload).pipe(
          map(data => DeprecatedIntelligenceSettingsActions.updateSuccess({ payload: data })),
          catchError(error =>
            of(DeprecatedIntelligenceSettingsActions.updateFailed({ payload: error })),
          ),
        ),
      ),
    ),
  );
}
